<div class="step-title">
  <button matIconButton type="button" aria-label="Indietro" (click)="flow.back()">
    <i class="fa-regular fa-arrow-left" aria-hidden="true"></i>
  </button>
  <span class="title-medium-emphasized">Dati bancari</span>
</div>

<div class="step-fields step-fields--half">
  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Tipo pagamento</mat-label>
    <mat-select placeholder="Seleziona" [value]="payment().condizione?.value ?? null" (selectionChange)="selectPayment($event.value)">
      @for (option of flow.payments(); track option.value) {
        <mat-option [value]="option.value">{{ option.label }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  @if (type() === 'CONTATTO') {
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Contatto telefonico *</mat-label>
      <input matInput type="tel" inputmode="numeric" maxlength="20" [formControl]="phoneControl">
      <mat-hint>(Obbligatorio)</mat-hint>
    </mat-form-field>
  }

  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Descrizione ABI (Banca)</mat-label>
    <input matInput [formControl]="abiControl" [matAutocomplete]="abiAuto">
    <i matSuffix class="fa-regular fa-magnifying-glass" aria-hidden="true"></i>
    <mat-autocomplete #abiAuto="matAutocomplete" [displayWith]="displayBank" (optionSelected)="selectAbi($event.option.value)">
      @for (bank of abiOptions(); track bank.abi) {
        <mat-option [value]="bank">
          <span class="body-large">{{ bank.banca }}</span>
          <span class="body-small option-detail">ABI {{ bank.abi }}</span>
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>

  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Descrizione CAB (Agenzia)</mat-label>
    <input matInput [formControl]="cabControl" [matAutocomplete]="cabAuto">
    <i matSuffix class="fa-regular fa-magnifying-glass" aria-hidden="true"></i>
    <mat-autocomplete #cabAuto="matAutocomplete" [displayWith]="displayBranch" (optionSelected)="selectCab($event.option.value)">
      @for (branch of cabOptions(); track $index) {
        <mat-option [value]="branch">
          <span class="body-large">{{ branch.descrizione }}</span>
          <span class="body-small option-detail">CAB {{ branch.cab }} · {{ branch.banca }}</span>
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>

  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Codice SDI</mat-label>
    <input matInput maxlength="7" autocapitalize="characters" spellcheck="false" [formControl]="sdiControl">
    @if (sdiControl.hasError('sdi')) {
      <mat-error>Il codice SDI è composto da 7 caratteri fra lettere maiuscole e numeri</mat-error>
    }
  </mat-form-field>
</div>

<div class="step-heading">
  <span class="title-medium-emphasized">Carica modulo dati bancari</span>
  <button matButton type="button" [disabled]="flow.downloading()" (click)="downloadTemplate()">
    <i class="fa-regular fa-arrow-down-to-bracket" aria-hidden="true"></i>
    <span class="label-large">Scarica template</span>
  </button>
</div>

@if (flow.downloading()) {
  <ord-new-customer-preparing />
}

<ord-new-customer-upload [files]="flow.bankDocuments()" [multiple]="true" (filesChange)="flow.bankDocuments.set($event)" />

@if (moduleWarning() && flow.bankDocuments().length === 0) {
  <div class="module-missing">
    <i class="fa-solid fa-circle-exclamation" aria-hidden="true"></i>
    <span class="body-medium">Invia quanto prima il modulo al <strong>Customer Service</strong> oppure caricalo nell'area dedicata</span>
  </div>
}

<mat-checkbox [checked]="payment().esenzioneIva" (change)="setVatExempt($event.checked)">Cliente in esenzione IVA</mat-checkbox>

@if (payment().esenzioneIva) {
  <span class="title-medium-emphasized">Carica documentazione esenzione</span>
  <ord-new-customer-upload [files]="flow.vatDocuments()" [multiple]="true" (filesChange)="flow.vatDocuments.set($event)" />
}

<div class="step-actions">
  <button matButton="filled" type="button" [disabled]="!valid()" (click)="continue()">Prosegui</button>
</div>
